export const CREATE_COMPANY = 'CREATE_COMPANY';
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_COMPANY = 'FETCH_COMPANY';
export const EDIT_COMPANY = 'EDIT_COMPANY';
export const DELETE_COMPANY = 'DELETE_COMPANY';
